import * as angular from 'angular';
import {IController} from 'angular';
import * as _ from "lodash";

interface ItemsList {list: any[], displayKey: string}

export class BringozItemsListDisplayComponent implements IController {

  items?: any;
  itemsObject?: any;
  itemsList?: ItemsList
  maxItems?: any;
  canCopy?: boolean;

  private viewItems: any;
  private extraItemsCount: any;
  public extraItems: string[];

  constructor() {
  }

  $onInit() {
    this.viewItems = [];

    if(this.itemsObject){
      this.items = Object.values(this.itemsObject);
    } else if (this.itemsList) {
      this.items = this._getItemsByList(this.itemsList);
    }
    this._initItems(this.items);
  }

  $onChanges(changes) {
    if (changes.items && !changes.items.isFirstChange()) {
      this.viewItems = [];
      this._initItems(this.items);
    }
    if (changes.itemsMap && !changes.itemsMap.isFirstChange()) {
      this.viewItems = [];
      this.items = Object.values(this.itemsObject);
      this._initItems(this.items);
    }
    if (changes.itemsList && !changes.itemsList.isFirstChange()) {
      this.viewItems = [];
      this.items = this._getItemsByList(this.itemsList);
      this._initItems(this.items);
    }
  };

  private _getItemsByList(itemsList: ItemsList) {
    return itemsList.list
      ?.filter((item) => {
        return !!item[this.itemsList.displayKey];
      })
      .map((item) => {
        return item[this.itemsList.displayKey]
      });
  }

  private _initItems(items) {
    this.extraItemsCount = undefined;

    if (_.get(items, 'length')) {

      this.viewItems = !_.isUndefined(this.maxItems) ? _.filter(items, (item, index) => {
        return index < this.maxItems;
      }) : items;

      if (items.length > this.viewItems.length) {
        this.extraItemsCount = `${!!this.maxItems ? '+' : ''}${(items.length - this.viewItems.length).toString()}`;
      }

      if (items.length > this.viewItems.length) {
        const itemsCopy = angular.copy(this.items);
        this.extraItems = itemsCopy.slice(this.viewItems.length);
      }
    }
  }

}


angular
  .module('bringoz.admin.commons')
  .component('bringozItemsListDisplay', {
    bindings: {
      items: '<?',
      itemsObject: '<?',
      itemsList: '<?',
      maxItems: '<?',
      canCopy: '<?',
    },
    template: require('./bringoz-items-list-display.html').default,
    controller: BringozItemsListDisplayComponent
  });
